class LoginModel {
  constructor({ email, password }) {
    this.email = email;
    this.password = password;
  }
}

export default LoginModel;